/*!
   Copyright 2022 Ron Buckton

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/

import { default as xxhash64Generated } from "./xxhash64.generated.js";

interface XXHash64WasmModule extends WebAssembly.Exports {
    mem: WebAssembly.Memory,
    xxh64: (ptr: number, len: number, seed: bigint) => bigint;
}

export const mem = (xxhash64Generated as XXHash64WasmModule | undefined)?.mem;
export const xxh64 = (xxhash64Generated as XXHash64WasmModule | undefined)?.xxh64;